import React from "react";
import styled from "styled-components";

import { BrowserRouter, Route, Routes } from "react-router-dom";

//---- ROUTES ----//
import PublicRoutes from "./routes/PublicRoutes";
import PrivateRoutes from "./routes/PrivateRoutes";

//---- LOGIN ----//
import LoginPage from "./pages/Login/LoginPage";
import RecoverPassword from "./pages/Login/RecoverPassword";
import ForgottenPassword from "./pages/Login/ForgottenPassword";

//---- USERS ----//
import NewUserPage from "./pages/Users/NewUser";
import ChangePassword from "./pages/Users/ChangePassword";

//---- GENERAL ----//
import Dashboard from "./pages/Dashboard";
import NewContractPage from "./pages/NewContract";
import Catalogs from "./pages/Catalogs/Catalogs";

//---- SINIESTROS ----//
import CapturaSiniestro from "./pages/CapturaSiniestro";
import ContratosYSiniestros from "./pages/Siniestros/ContratosYSiniestros";


const Container = styled.div`
  width: 100%;
`;

export default function App() {
  return (
    <Container>
      <BrowserRouter>
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route path={"/"} element={<Dashboard />} />
            <Route path={"/nuevo-contrato"} element={<NewContractPage />} />
            <Route path={"/captura-siniestro"} element={<CapturaSiniestro />} />
            <Route path={"/contratos-siniestros"} element={<ContratosYSiniestros />} />
            <Route path={"/nuevo-usuario"} element={<NewUserPage />} />
            <Route path={"/cambiar-contrasena"} element={<ChangePassword />} />
            <Route path={"/catalogos"} element={<Catalogs/>} />
          </Route>
          <Route element={<PublicRoutes />}>
            <Route path={"/olvide-mi-contrasena"} element={<RecoverPassword />} />
            <Route path={"/cambiar-contrasena/:token"} element={<ForgottenPassword />} />
            <Route path={"/login"} element={<LoginPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Container>
  );
}
